import YubinBango from './yubinbango.js';

export const convertToAddress = (zipcode) => {
  return new Promise((res) => new YubinBango.Core(zipcode, res));
};
